(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mr-checkout-recovery"] && !Shopify.designMode) return;
  try {
    (() => {
  function start() {
    if (!document.querySelector('.Cart--expanded')) return;
    function visible(element) {
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    }
    function controls(root) {
      const found = [...root.querySelectorAll('button, a, input[type="submit"], [role="button"]')];
      root.querySelectorAll('*').forEach(element => {
        if (element.shadowRoot) found.push(...controls(element.shadowRoot));
      });
      return found;
    }
    function check() {
      const native = document.querySelector('.Cart--expanded .Cart__Checkout[name="checkout"]');
      if (!native) return;
      const replacement = controls(document).some(element => element !== native && !element.disabled && /checkout/i.test(element.textContent || element.getAttribute('aria-label') || element.value || '') && visible(element));
      const recover = !replacement && (native.classList.contains('mr-checkout-recovery') || !visible(native));
      if (native.classList.contains('mr-checkout-recovery') !== recover) native.classList.toggle('mr-checkout-recovery', recover);
    }
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; check(); });
    });
    setTimeout(() => {
      check();
      observer.observe(document.body, {subtree:true,childList:true});
    }, 4000);
    window.addEventListener('pageshow', check);
    window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mr-instalment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-instalment')) {
  customElements.define('mr-instalment', class extends HTMLElement {
    connectedCallback() {
      this.prices = JSON.parse(this.querySelector('script').textContent);
      this.form = this.closest('form');
      this.variantHandler = event => this.update(event.detail?.variant?.id);
      this.changeHandler = () => requestAnimationFrame(() => this.update(this.form?.querySelector('[name="id"]')?.value));
      document.addEventListener('variant:changed', this.variantHandler);
      this.form?.addEventListener('change', this.changeHandler);
    }
    update(id) {
      if (!(String(id) in this.prices)) return;
      const amount = Math.round(this.prices[id] / 4) / 100;
      this.querySelector('[data-instalment-amount]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency}).format(amount);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.variantHandler);
      this.form?.removeEventListener('change', this.changeHandler);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mr-pair-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-pair-bundle')) {
  customElements.define('mr-pair-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.mode = 'single';
      this.querySelector('.mr-pair__modes').hidden = false;
      this.catalog = new Map([...this.querySelectorAll('[data-pair]')].map(button => [button.dataset.pair, {button, title:button.dataset.title, variants:JSON.parse(button.dataset.variants)}]));
      const catalog = this.querySelector('.mr-pair__catalog');
      const style = this.catalog.get(this.dataset.current)?.title.split(' - ')[0];
      [...this.catalog.values()].sort((a,b) => Number(b.title.split(' - ')[0] === style) - Number(a.title.split(' - ')[0] === style)).forEach(product => catalog.append(product.button));
      this.slots = Array.from({length:2}, () => ({product:null, variant:null, explicit:false}));
      this.active = 0;
      this.sharedSize = null;
      this.busy = false;
      this.addButton = this.querySelector('[data-add]');
      this.addLabel = this.addButton.textContent;
      this.nextButton = this.querySelector('[data-next]');
      this.nextLabel = this.nextButton.textContent;
      this.editLabel = this.querySelector('[data-editing]').textContent;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || this.busy || button.disabled) return;
        if (button.hasAttribute('data-mode-toggle')) this.mode = button.dataset.modeToggle;
        else if (button.hasAttribute('data-slot')) this.active = Number(button.dataset.slot);
        else if (button.hasAttribute('data-pair')) this.chooseProduct(button.dataset.pair);
        else if (button.hasAttribute('data-variant')) this.chooseSize(button.dataset.variant);
        else if (button.hasAttribute('data-next')) this.active = (this.active + 1) % 2;
        else if (button.hasAttribute('data-add')) { this.add(); return; }
        this.render();
      });
      this.chooseProduct(this.dataset.current);
      this.render();
    }
    chooseProduct(id) {
      const product = this.catalog.get(id);
      if (!product) return;
      const slot = this.slots[this.active];
      const previous = slot.variant?.option1;
      slot.product = id;
      slot.variant = this.matchVariant(product.variants, slot.explicit ? previous : this.sharedSize);
    }
    matchVariant(variants, size) {
      if (!size) return null;
      const exact = variants.find(variant => variant.option1 === size);
      if (exact) return exact.available ? exact : null;
      const equivalents = {'30':'S','32':'M','34':'L','36':'XL','S':'30','M':'32','L':'34','XL':'36'};
      return variants.find(variant => variant.available && variant.option1 === equivalents[size]) || null;
    }
    chooseSize(id) {
      const slot = this.slots[this.active];
      const variant = this.catalog.get(slot.product)?.variants.find(v => String(v.id) === id && v.available);
      if (!variant) return;
      slot.variant = variant;
      slot.explicit = this.active !== 0;
      if (this.active === 0) {
        this.sharedSize = variant.option1;
        this.slots.slice(1).forEach(other => {
          if (other.product && !other.explicit) other.variant = this.matchVariant(this.catalog.get(other.product).variants, this.sharedSize);
        });
      }
    }
    render() {
      this.dataset.mode = this.mode;
      this.querySelector('[data-bundle-panel]').hidden = this.mode !== 'bundle';
      this.querySelectorAll('[data-mode-toggle]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.modeToggle === this.mode));
        button.disabled = this.busy;
        if (button.dataset.modeToggle === 'bundle') button.setAttribute('aria-expanded', String(this.mode === 'bundle'));
      });
      const slot = this.slots[this.active];
      this.querySelectorAll('[data-slot]').forEach((button,index) => {
        const selection = this.slots[index];
        button.setAttribute('aria-pressed', String(index === this.active));
        button.querySelector('[data-summary]').textContent = selection.product ? this.catalog.get(selection.product).title + ' · ' + (selection.variant?.option1 || this.dataset.sizeLabel) : this.dataset.choose;
      });
      this.catalog.forEach((product,id) => product.button.setAttribute('aria-pressed', String(slot.product === id)));
      this.querySelector('[data-editing]').textContent = this.editLabel.replace('[number]', this.active + 1);
      this.querySelector('[data-selected]').textContent = slot.product ? this.catalog.get(slot.product).title : this.dataset.choose;
      const sizes = this.querySelector('[data-sizes]');
      sizes.replaceChildren();
      if (slot.product) this.catalog.get(slot.product).variants.forEach(variant => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.variant = variant.id; button.textContent = variant.option1;
        button.disabled = !variant.available || this.busy;
        button.setAttribute('aria-pressed',String(slot.variant?.id === variant.id));
        sizes.append(button);
      });
      const ready = this.slots.filter(item => item.variant).length;
      this.querySelector('[data-progress]').textContent = this.dataset.count.replace('[count]',ready);
      this.nextButton.hidden = ready === 2;
      this.nextButton.disabled = !slot.variant || this.busy;
      this.nextButton.textContent = this.nextLabel.replace('[number]', (this.active + 1) % 2 + 1);
      this.addButton.disabled = ready !== 2 || this.busy;
      this.querySelectorAll('[data-slot],[data-pair]').forEach(button => button.disabled = this.busy);
      this.addButton.textContent = this.busy ? this.dataset.adding : this.addLabel;
    }
    async add() {
      if (this.mode !== 'bundle' || this.busy || this.slots.some(slot => !slot.variant)) return;
      this.busy = true; this.render();
      const status = this.querySelector('[data-status]'); status.textContent = '';
      const quantities = new Map();
      this.slots.forEach(slot => quantities.set(slot.variant.id, (quantities.get(slot.variant.id) || 0) + 1));
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[...quantities].map(([id,quantity]) => ({id,quantity}))})});
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || this.dataset.error);
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        this.busy = false; this.render();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mr-shorts-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-shorts-bundle')) {
  customElements.define('mr-shorts-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[role="status"]');
      this.sizes = this.querySelector('[data-second-sizes]');
      this.label = this.button.textContent;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled || this.busy) return;
        if (button.hasAttribute('data-first')) this.selectFirst(button);
        else if (button.hasAttribute('data-product')) this.selectProduct(button);
        else if (button.hasAttribute('data-second')) this.selectSecond(button, true);
        else if (button.hasAttribute('data-more')) {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          this.moreLabel ||= button.textContent;
          this.querySelectorAll('[data-other]').forEach(item => item.hidden = !expanded && item.getAttribute('aria-pressed') !== 'true');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.collapse : this.moreLabel;
        }
        else if (button.hasAttribute('data-add')) this.add();
      });
      this.section = this.closest('.shopify-section');
      this.variantHandler = event => {
        if (!this.section?.contains(event.target)) return;
        const variant = event.detail?.variant;
        const button = Array.from(this.querySelectorAll('[data-first]')).find(b => b.dataset.first === String(variant?.id));
        if (button && !button.disabled) this.selectFirst(button);
      };
      document.addEventListener('variant:changed', this.variantHandler);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.variantHandler);
      this.ready = false;
    }
    mark(selector, selected) {
      this.querySelectorAll(selector).forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
    }
    selectFirst(button) {
      this.first = button.dataset.first;
      this.size = button.dataset.size;
      this.mark('[data-first]', button);
      this.querySelector('[data-first-label]').textContent = this.size;
      if (!this.secondTouched) this.matchSize();
      this.refresh();
    }
    selectProduct(button) {
      this.mark('[data-product]', button);
      this.secondTitle = button.dataset.title;
      const template = Array.from(this.querySelectorAll('template')).find(t => t.dataset.options === button.dataset.product);
      this.sizes.replaceChildren(template.content.cloneNode(true));
      this.second = null;
      this.secondTouched = false;
      this.querySelector('[data-second-label]').textContent = this.secondTitle + ' · ' + this.dataset.selectSize;
      this.matchSize();
      this.refresh();
    }
    matchSize() {
      const match = Array.from(this.sizes.querySelectorAll('button')).find(b => b.dataset.size === this.size && !b.disabled);
      if (match) this.selectSecond(match, false);
      else {
        this.second = null;
        this.mark('[data-second]', null);
        if (this.secondTitle) this.querySelector('[data-second-label]').textContent = this.secondTitle + ' · ' + this.dataset.selectSize;
      }
    }
    selectSecond(button, touched) {
      this.second = button.dataset.second;
      this.secondTouched = touched;
      this.mark('[data-second]', button);
      this.querySelector('[data-second-label]').textContent = this.secondTitle + ' · ' + button.dataset.size;
      this.refresh();
    }
    refresh() {
      this.button.disabled = this.busy || !this.first || !this.second;
      this.status.textContent = '';
    }
    async add() {
      if (this.busy || !this.first || !this.second) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.adding;
      this.status.textContent = '';
      const quantities = new Map();
      [this.first, this.second].forEach(id => quantities.set(id, (quantities.get(id) || 0) + 1));
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:Array.from(quantities, ([id,quantity]) => ({id:Number(id),quantity}))})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        this.status.textContent = this.dataset.success;
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = error.message === 'Failed to fetch' ? this.dataset.error : error.message;
        this.busy = false;
        this.button.disabled = false;
        this.button.textContent = this.label;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mr-tee-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-tee-bundle')) {
  customElements.define('mr-tee-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.mode = 'single';
      this.querySelector('.mr-tee__modes').hidden = false;
      this.catalog = new Map([...this.querySelectorAll('[data-tee]')].map(button => [button.dataset.tee, {button, title:button.dataset.title, variants:JSON.parse(button.dataset.variants)}]));
      const catalog = this.querySelector('.mr-tee__catalog');
      [...this.catalog.values()].sort((a,b) => Number(b.title.startsWith('Reginald Tee -')) - Number(a.title.startsWith('Reginald Tee -'))).forEach(product => catalog.append(product.button));
      this.slots = Array.from({length:3}, () => ({product:null, variant:null, explicit:false}));
      this.active = 0;
      this.sharedSize = null;
      this.busy = false;
      this.addButton = this.querySelector('[data-add]');
      this.addLabel = this.addButton.textContent;
      this.nextButton = this.querySelector('[data-next]');
      this.nextLabel = this.nextButton.textContent;
      this.editLabel = this.querySelector('[data-editing]').textContent;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || this.busy || button.disabled) return;
        if (button.hasAttribute('data-mode-toggle')) this.mode = button.dataset.modeToggle;
        else if (button.hasAttribute('data-slot')) this.active = Number(button.dataset.slot);
        else if (button.hasAttribute('data-tee')) this.chooseProduct(button.dataset.tee);
        else if (button.hasAttribute('data-variant')) this.chooseSize(button.dataset.variant);
        else if (button.hasAttribute('data-next')) this.active = (this.active + 1) % 3;
        else if (button.hasAttribute('data-add')) { this.add(); return; }
        this.render();
      });
      this.chooseProduct(this.dataset.current);
      this.render();
    }
    chooseProduct(id) {
      const product = this.catalog.get(id);
      if (!product) return;
      const slot = this.slots[this.active];
      const previous = slot.variant?.option1;
      slot.product = id;
      slot.variant = product.variants.find(v => v.available && v.option1 === (slot.explicit ? previous : this.sharedSize)) || null;
    }
    chooseSize(id) {
      const slot = this.slots[this.active];
      const variant = this.catalog.get(slot.product)?.variants.find(v => String(v.id) === id && v.available);
      if (!variant) return;
      slot.variant = variant;
      slot.explicit = this.active !== 0;
      if (this.active === 0) {
        this.sharedSize = variant.option1;
        this.slots.slice(1).forEach(other => {
          if (other.product && !other.explicit) other.variant = this.catalog.get(other.product).variants.find(v => v.available && v.option1 === this.sharedSize) || null;
        });
      }
    }
    render() {
      this.dataset.mode = this.mode;
      this.querySelector('[data-bundle-panel]').hidden = this.mode !== 'bundle';
      this.querySelectorAll('[data-mode-toggle]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.modeToggle === this.mode));
        button.disabled = this.busy;
        if (button.dataset.modeToggle === 'bundle') button.setAttribute('aria-expanded', String(this.mode === 'bundle'));
      });
      const slot = this.slots[this.active];
      this.querySelectorAll('[data-slot]').forEach((button,index) => {
        const selection = this.slots[index];
        button.setAttribute('aria-pressed', String(index === this.active));
        button.querySelector('[data-summary]').textContent = selection.product ? this.catalog.get(selection.product).title.replace(' Tee','') + ' · ' + (selection.variant?.option1 || this.dataset.sizeLabel) : this.dataset.choose;
      });
      this.catalog.forEach((product,id) => product.button.setAttribute('aria-pressed', String(slot.product === id)));
      this.querySelector('[data-editing]').textContent = this.editLabel.replace('[number]', this.active + 1);
      this.querySelector('[data-selected]').textContent = slot.product ? this.catalog.get(slot.product).title : this.dataset.choose;
      const sizes = this.querySelector('[data-sizes]');
      sizes.replaceChildren();
      if (slot.product) this.catalog.get(slot.product).variants.forEach(variant => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.variant = variant.id; button.textContent = variant.option1;
        button.disabled = !variant.available || this.busy;
        button.setAttribute('aria-pressed',String(slot.variant?.id === variant.id));
        sizes.append(button);
      });
      const ready = this.slots.filter(item => item.variant).length;
      this.querySelector('[data-progress]').textContent = this.dataset.count.replace('[count]',ready);
      this.nextButton.hidden = ready === 3;
      this.nextButton.disabled = !slot.variant || this.busy;
      this.nextButton.textContent = this.nextLabel.replace('[number]', (this.active + 1) % 3 + 1);
      this.addButton.disabled = ready !== 3 || this.busy;
      this.querySelectorAll('[data-slot],[data-tee]').forEach(button => button.disabled = this.busy);
      this.addButton.textContent = this.busy ? this.dataset.adding : this.addLabel;
    }
    async add() {
      if (this.mode !== 'bundle' || this.busy || this.slots.some(slot => !slot.variant)) return;
      this.busy = true; this.render();
      const status = this.querySelector('[data-status]'); status.textContent = '';
      const quantities = new Map();
      this.slots.forEach(slot => quantities.set(slot.variant.id, (quantities.get(slot.variant.id) || 0) + 1));
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[...quantities].map(([id,quantity]) => ({id,quantity}))})});
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || this.dataset.error);
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        this.busy = false; this.render();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
